import { Injectable } from '@angular/core';
import { DefaultRoutePageMetaResolver, TranslationService } from '@spartacus/core';
import { Observable } from 'rxjs';
import { BranchForm } from '../uig-branches/uig-branches.models';
import { UigCurrentBranchService } from './uig-current-branch.service';

@Injectable({ providedIn: 'root' })
export class UigBranchRoutePageMetaResolver extends DefaultRoutePageMetaResolver {
  constructor(
    translation: TranslationService,
    protected currentItemService: UigCurrentBranchService
  ) {
    super(translation);
  }

  protected getParams(): Observable<BranchForm> {
    return this.currentItemService.item$;
  }
}